import React from 'react';

const LegalModal = ({ isOpen, onClose, type }) => {
    if (!isOpen) return null;

    const modalStyles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
        },
        modal: {
            backgroundColor: '#1a1a1a',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '800px',
            maxHeight: '80vh',
            width: '100%',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
            overflow: 'auto'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '30px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            paddingBottom: '20px'
        },
        title: {
            fontSize: '24px',
            fontWeight: '600',
            color: '#ffffff',
            margin: 0
        },
        closeButton: {
            background: 'none',
            border: 'none',
            color: '#a0a0a0',
            fontSize: '24px',
            cursor: 'pointer',
            padding: '5px',
            borderRadius: '4px',
            transition: 'color 0.3s'
        },
        content: {
            color: '#e0e0e0',
            lineHeight: '1.6',
            fontSize: '14px'
        },
        section: {
            marginBottom: '25px'
        },
        sectionTitle: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#FF0066',
            marginBottom: '15px'
        },
        paragraph: {
            marginBottom: '15px'
        },
        list: {
            marginLeft: '20px',
            marginBottom: '15px'
        },
        listItem: {
            marginBottom: '8px'
        }
    };

    const termsContent = (
        <div style={modalStyles.content}>
            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>RecruitmentX Terms of Use</h3>
                <p style={modalStyles.paragraph}>
                    Welcome to Recruitment X!
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>1. Eligibility</h3>
                <p style={modalStyles.paragraph}>
                    To use our Services, you must be at least the legal age of majority in your jurisdiction. 
                    By using our Services, you confirm that you meet this requirement and have the authority to enter into a binding agreement.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>2. Account Registration and Security</h3>
                <p style={modalStyles.paragraph}>
                    Some features of our Services may require account registration. You are responsible for maintaining 
                    the confidentiality of your account credentials and for all activities conducted through your account. 
                    If you suspect unauthorized access, notify us immediately.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>3. Acceptable Use</h3>
                <p style={modalStyles.paragraph}>
                    You agree to use our Services lawfully and in compliance with all applicable regulations. 
                    Prohibited activities include but are not limited to:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}>Engaging in fraudulent or deceptive practices</li>
                    <li style={modalStyles.listItem}>Distributing harmful software, spam, or unauthorized advertising</li>
                    <li style={modalStyles.listItem}>Attempting to compromise the security or integrity of our systems</li>
                    <li style={modalStyles.listItem}>Infringing on intellectual property rights</li>
                </ul>
                <p style={modalStyles.paragraph}>
                    We reserve the right to suspend or terminate access if we determine that you have violated these terms.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>4. Intellectual Property</h3>
                <p style={modalStyles.paragraph}>
                    All content within our Services, including but not limited to text, images, trademarks, and software, 
                    is owned by or licensed to us. You may not copy, modify, distribute, or otherwise use any content without prior written permission.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>5. Third-Party Links and Content</h3>
                <p style={modalStyles.paragraph}>
                    Our Services may include links to third-party websites or resources. We do not endorse or assume 
                    responsibility for any third-party content. Your interactions with third-party sites are at your own risk.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>6. Limitation of Liability</h3>
                <p style={modalStyles.paragraph}>
                    To the fullest extent permitted by law, we are not liable for any indirect, incidental, special, 
                    or consequential damages arising from your use of our Services. Our total liability, under any circumstance, 
                    shall not exceed the amount paid by you, if any, for using our Services.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>7. Indemnification</h3>
                <p style={modalStyles.paragraph}>
                    You agree to indemnify and hold us harmless from any claims, losses, or damages, including legal fees, 
                    arising from your use of our Services or your violation of these Terms.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>8. Changes to These Terms</h3>
                <p style={modalStyles.paragraph}>
                    We may update these Terms at any time. Any changes will take effect upon posting. Continued use of 
                    our Services after updates constitutes acceptance of the revised Terms.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>9. Termination</h3>
                <p style={modalStyles.paragraph}>
                    We reserve the right to suspend or terminate your access to our Services at our discretion, 
                    without prior notice, if we determine a breach of these Terms has occurred.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>10. Governing Law</h3>
                <p style={modalStyles.paragraph}>
                    These Terms are governed by the laws of New South Wales, Australia. Any disputes arising from 
                    these Terms shall be resolved in the courts of New South Wales, Australia.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>11. Contact Information</h3>
                <p style={modalStyles.paragraph}>
                    For questions regarding these Terms, please contact us at hello@recruitmentx.ai
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>12. Confidentiality</h3>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}>Both parties must keep each other's confidential information secure, sharing it only when necessary for the agreement, or if legally required.</li>
                    <li style={modalStyles.listItem}>Each party must protect the other's information with at least the same care they use for their own confidential data.</li>
                    <li style={modalStyles.listItem}>Any breaches may result in irreparable harm, allowing for injunctive relief.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>13. Indemnities, Liability & Disclaimers</h3>
                <p style={modalStyles.paragraph}>
                    <strong>Indemnities:</strong> Recruitment X will indemnify the client against third-party IP claims, 
                    while the client indemnifies Recruitment X for violations of laws or rights.
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Liability:</strong> Neither party is liable for special or indirect damages (e.g., lost profits), 
                    except in certain cases (fraud, breach of warranties, etc.).
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Disclaimers:</strong> Recruitment X disclaims responsibility for inaccuracies in its AI service, 
                    which should not be relied on without verification.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>14. Implementation Services</h3>
                <p style={modalStyles.paragraph}>
                    Recruitment X must perform implementation services with due care, and if they breach this, 
                    they must re-perform or refund the fees.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>15. Third-Party Services</h3>
                <p style={modalStyles.paragraph}>
                    Use of third-party services via Recruitment X is governed by the third party's terms, 
                    and Recruitment X isn't liable for those services.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>16. Fees and Pricing</h3>
                <p style={modalStyles.paragraph}>
                    <strong>Pricing Structure:</strong> Access to certain RecruitmentX Services requires payment of fees, 
                    which are set out in our Global Pricing Document, available at https://recruitmentx.ai/pricing.pdf or provided upon request.
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Localised Pricing:</strong> We use a market-based pricing approach tailored to the purchasing 
                    power and business norms of each region.
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Changes to Pricing:</strong> We may revise our pricing at any time. Updates will be published 
                    in the Pricing Document and take effect from the beginning of your next billing period.
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Period of Service:</strong> The period of service is determined during the sign-up process. For recurring plans, a discount is provided in returned for a period of commitment. 
                    Cancellation fees may apply for recurring plans where a period of commitment is selected
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>17. Termination</h3>
                <p style={modalStyles.paragraph}>
                    The agreement can be terminated if there's a breach, insolvency, or cessation of business. 
                    Upon termination, client access to Recruitment X's services ends.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>18. Dispute Resolution</h3>
                <p style={modalStyles.paragraph}>
                    Disputes should first be attempted to resolve via negotiation. If unresolved, 
                    mediation or arbitration will be used.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>19. Force Majeure</h3>
                <p style={modalStyles.paragraph}>
                    Neither party is liable for delays due to events beyond their control (e.g., natural disasters, 
                    government actions). If a force majeure event lasts over 30 days, the agreement may be terminated.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>20. General Provisions</h3>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Amendments:</strong> Any changes to the agreement must be written.</li>
                    <li style={modalStyles.listItem}><strong>Governing Law:</strong> This Agreement shall be governed by the laws of the State of New South Wales, Australia. The parties submit to the exclusive jurisdiction of the courts in that State.</li>
                    <li style={modalStyles.listItem}><strong>No Partnership:</strong> This is not a partnership or employment relationship.</li>
                    <li style={modalStyles.listItem}><strong>Costs:</strong> Each party bears its own legal costs.</li>
                    <li style={modalStyles.listItem}><strong>Entire Agreement:</strong> This document supersedes prior agreements.</li>
                </ul>
            </div>
        </div>
    );

    const privacyContent = (
        <div style={modalStyles.content}>
            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>Privacy & Policy</h3>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>1. Data Collection and Usage</h3>
                <p style={modalStyles.paragraph}>
                    We collect and process personal data solely for the purpose of providing our services to hiring managers and recruiters. This includes:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Candidate Information:</strong> CVs, cover letters, application forms, and any additional materials provided by candidates.</li>
                    <li style={modalStyles.listItem}><strong>Customer Data:</strong> Information necessary for account management, communication, and service provision.</li>
                </ul>
                <p style={modalStyles.paragraph}>
                    We do not use this data for any other purposes without explicit consent.
                </p>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>2. Data Access Controls</h3>
                <p style={modalStyles.paragraph}>
                    Access to personal data is strictly limited:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Authorized Personnel Only (Zero Trust Principles):</strong> Only employees who need access to perform their job duties are granted permission.</li>
                    <li style={modalStyles.listItem}><strong>Role-Based Access:</strong> Access rights are assigned based on job function and are regularly reviewed.</li>
                    <li style={modalStyles.listItem}><strong>2FA:</strong> All employees use Two Factor Authentication</li>
                    <li style={modalStyles.listItem}><strong>Confidentiality Agreements:</strong> All employees and contractors sign binding agreements to protect customer and candidate data.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>3. Data Security Measures</h3>
                <p style={modalStyles.paragraph}>
                    We employ robust security measures to protect data:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Encryption:</strong> All data is encrypted both in transit and at rest using industry-standard protocols.</li>
                    <li style={modalStyles.listItem}><strong>Secure Infrastructure:</strong> Our servers are hosted in secure facilities with advanced physical and network security.</li>
                    <li style={modalStyles.listItem}><strong>Regular Audits:</strong> We conduct periodic security assessments and vulnerability scans to identify and mitigate risks.</li>
                    <li style={modalStyles.listItem}><strong>Firewall and Antivirus Protection:</strong> Continuous monitoring to prevent unauthorized access and malware threats.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>4. Prevention of Data Sharing and Leakage</h3>
                <p style={modalStyles.paragraph}>
                    We enforce strict policies to prevent unauthorized data dissemination:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>No Unauthorized Sharing:</strong> We do not share personal data with third parties unless required by law or with explicit customer consent.</li>
                    <li style={modalStyles.listItem}><strong>Data Handling Procedures:</strong> Clear guidelines are in place for data processing, storage, and disposal.</li>
                    <li style={modalStyles.listItem}><strong>Monitoring and Alerts:</strong> Systems are in place to detect and alert us to any unusual data access or transfer activities.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>5. Data Breach Response Policy</h3>
                <p style={modalStyles.paragraph}>
                    In the unlikely event of a data breach:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Immediate Action:</strong> We will promptly identify, contain, and mitigate the breach.</li>
                    <li style={modalStyles.listItem}><strong>Notification:</strong> Affected customers and, if necessary, regulatory bodies will be informed without undue delay.</li>
                    <li style={modalStyles.listItem}><strong>Investigation:</strong> A thorough investigation will be conducted to determine the cause and extent.</li>
                    <li style={modalStyles.listItem}><strong>Preventive Measures:</strong> Steps will be taken to prevent future incidents, including policy updates and additional security measures.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>6. Data Retention and Deletion</h3>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Retention Period:</strong> Personal data is retained only for as long as necessary to fulfill the purposes for which it was collected or as required by law.</li>
                    <li style={modalStyles.listItem}><strong>Secure Deletion:</strong> Upon request or when data is no longer needed, we securely delete or anonymize personal information.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>7. Compliance with Laws and Regulations</h3>
                <p style={modalStyles.paragraph}>
                    We comply with all applicable data protection laws and regulations, including:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Local Data Protection Laws:</strong> Compliance with country-specific regulations where we operate.</li>
                    <li style={modalStyles.listItem}><strong>General Data Protection Regulation (GDPR):</strong> For customers and candidates within the European Union.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>8. Customer and Candidate Rights</h3>
                <p style={modalStyles.paragraph}>
                    Individuals have the right to:
                </p>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Access Data:</strong> Request a copy of the personal data we hold about them.</li>
                    <li style={modalStyles.listItem}><strong>Rectify Data:</strong> Request corrections to any inaccurate or incomplete data.</li>
                    <li style={modalStyles.listItem}><strong>Erase Data:</strong> Request deletion of their personal data, subject to legal and contractual obligations.</li>
                    <li style={modalStyles.listItem}><strong>Restrict Processing:</strong> Request limitations on how their data is used.</li>
                    <li style={modalStyles.listItem}><strong>Data Portability:</strong> Receive their data in a structured, commonly used format.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>9. Training and Awareness</h3>
                <ul style={modalStyles.list}>
                    <li style={modalStyles.listItem}><strong>Employee Training:</strong> Regular training is provided to all staff on data protection principles and cybersecurity best practices.</li>
                    <li style={modalStyles.listItem}><strong>Policy Updates:</strong> Policies are reviewed and updated regularly to reflect changes in laws, technology, and operational practices.</li>
                </ul>
            </div>

            <div style={modalStyles.section}>
                <h3 style={modalStyles.sectionTitle}>10. Contact Information</h3>
                <p style={modalStyles.paragraph}>
                    For any questions, concerns, or requests regarding this Privacy and Data Protection Statement, please contact our Data Protection Officer:
                </p>
                <p style={modalStyles.paragraph}>
                    <strong>Email:</strong> james@recruitmentx.com<br/>
                    <strong>Phone:</strong> +61 414173508
                </p>
                <p style={modalStyles.paragraph}>
                    By entrusting your data to Recruitment X, you acknowledge and agree to this Privacy and Data Protection Statement. 
                    We are dedicated to maintaining the highest standards of data protection to ensure your information remains secure and confidential.
                </p>
            </div>
        </div>
    );

    return (
        <div style={modalStyles.overlay} onClick={onClose}>
            <div style={modalStyles.modal} onClick={(e) => e.stopPropagation()}>
                <div style={modalStyles.header}>
                    <h2 style={modalStyles.title}>
                        {type === 'terms' ? 'Terms of Service' : 'Privacy Policy'}
                    </h2>
                    <button 
                        style={modalStyles.closeButton}
                        onClick={onClose}
                        onMouseEnter={(e) => e.target.style.color = '#ffffff'}
                        onMouseLeave={(e) => e.target.style.color = '#a0a0a0'}
                    >
                        ×
                    </button>
                </div>
                {type === 'terms' ? termsContent : privacyContent}
            </div>
        </div>
    );
};

export default LegalModal;
